// Microsoft (Entra ID) girişi — yalnız Megafood tenant'ı (#27). Yalnız redirect akışı kullanılır;
// sessiz yenileme başarısız olursa kullanıcı yeniden giriş sayfasına yönlenir.
import { PublicClientApplication, type AccountInfo } from '@azure/msal-browser';

const TENANT_ID = 'f6933eae-4753-46b5-b8c9-e06ae8f439a0';
const CLIENT_ID = 'e5689b55-340c-4cca-92f9-783019e429ad'; // ESL Web
const SCOPES = [`api://${CLIENT_ID}/access_as_user`];

const msal = new PublicClientApplication({
  auth: {
    clientId: CLIENT_ID,
    authority: `https://login.microsoftonline.com/${TENANT_ID}`,
    redirectUri: `${window.location.origin}/`,
  },
  cache: { cacheLocation: 'localStorage' },
});

// Girişli hesabı döndürür; yoksa Microsoft giriş sayfasına yönlendirir (dönen promise çözülmez).
export async function signIn(): Promise<AccountInfo> {
  await msal.initialize();
  const result = await msal.handleRedirectPromise();
  const account = result?.account ?? msal.getAllAccounts()[0];
  if (account) {
    msal.setActiveAccount(account);
    return account;
  }
  await msal.loginRedirect({ scopes: SCOPES });
  return new Promise(() => {});
}

// API isteğinin Authorization başlığı.
export async function authHeader(): Promise<Record<string, string>> {
  const account = msal.getActiveAccount();
  if (!account) return {};
  try {
    const { accessToken } = await msal.acquireTokenSilent({ scopes: SCOPES, account });
    return { Authorization: `Bearer ${accessToken}` };
  } catch {
    await msal.acquireTokenRedirect({ scopes: SCOPES, account });
    return new Promise(() => {});
  }
}
